module.exports = __webpack_public_path__ + "img/envelopamento.b2a993d0.jpg";